export enum PDF_DOCUMENT_TYPE {
  MEDIA_PACK = 'mediaPack',
  CONTENT = 'content',
  TIKTOK_CONTENT = 'tiktokContent',
  YOUTUBE_CONTENT = 'youtubeContent',
  SAVED_LIST_CONTENT = 'savedListContent',
}

export const MAX_CREATORS_FOR_LIST_PDF = 400;
